var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAstronaut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 344,
    viewBox: "0 0 291 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_373_3032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.938 127.688C141.218 114.053 143.892 93.6776 132.912 82.1781C121.932 70.6786 101.454 72.4097 87.1748 86.0447C72.8952 99.6796 70.2205 120.055 81.2008 131.555C92.1812 143.054 112.658 141.323 126.938 127.688Z",
    stroke: "#BBBBBB",
    strokeWidth: 5.72067,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3562 98.6118C38.2125 95.8845 38.317 91.358 35.5897 88.5017C32.8623 85.6454 28.3359 85.5409 25.4795 88.2682C22.6232 90.9956 22.5187 95.522 25.246 98.3783C27.9734 101.235 32.4999 101.339 35.3562 98.6118Z",
    stroke: "#BBBBBB",
    strokeWidth: 5.72067,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.081 113.07C152.593 97.9444 148.656 81.3955 137.13 69.3245C118.947 50.2819 88.772 49.585 69.7294 67.7679C50.6869 85.9507 49.9899 116.126 68.1728 135.169C79.6988 147.24 96.0483 151.937 111.32 149.126",
    stroke: "#BBBBBB",
    strokeWidth: 5.72067,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.84 108.383C162.432 122.482 156.175 136.169 145.121 146.724C134.067 157.279 120.106 162.897 105.957 163.653C99.6625 188.166 105.773 215.275 124.539 234.928C153.448 265.204 201.43 266.312 231.706 237.403C261.982 208.494 263.09 160.511 234.181 130.236C215.416 110.583 188.618 103.227 163.84 108.383Z",
    stroke: "#BBBBBB",
    strokeWidth: 5.72067,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.84 108.383C158.809 109.431 153.863 110.989 149.081 113.07C147.052 121.803 142.545 130.068 135.574 136.725C128.602 143.382 120.141 147.506 111.32 149.126C109.02 153.807 107.236 158.675 105.957 163.653C120.106 162.897 134.067 157.279 145.121 146.724C156.175 136.169 162.432 122.482 163.84 108.383Z",
    stroke: "#BBBBBB",
    strokeWidth: 5.72067,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3438 99.6465L61.009 125.478",
    stroke: "#BBBBBB",
    strokeWidth: 5.72067,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.574 136.725L231.706 237.403",
    stroke: "#BBBBBB",
    strokeWidth: 5.72067,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.679 146.141L176.461 133.937",
    stroke: "#BBBBBB",
    strokeWidth: 5.72067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.576 129.308C60.5743 127.211 57.2582 127.135 55.1619 129.136C53.0656 131.138 52.989 134.454 54.9907 136.55L54.6615 136.206L67.4056 149.552L67.1719 149.308C69.1735 151.404 72.4896 151.48 74.5859 149.479C76.6822 147.477 76.7588 144.161 74.7572 142.065L62.576 129.308Z",
    stroke: "#BBBBBB",
    strokeWidth: 5.72067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.533 63.4631C129.532 61.3668 129.608 58.0506 131.705 56.049C133.801 54.0473 137.117 54.1239 139.119 56.2202L138.79 55.8754L151.534 69.2221L151.3 68.9773C153.302 71.0736 153.225 74.3898 151.129 76.3914C149.032 78.3931 145.716 78.3165 143.715 76.2202L131.533 63.4631Z",
    stroke: "#BBBBBB",
    strokeWidth: 5.72067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4774 92.686C97.4774 92.686 101.63 88.0613 107.383 87.1826C111.599 86.5382 115.487 86.6954 120.127 90.1744",
    stroke: "#BBBBBB",
    strokeWidth: 5.72067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.536 130.976L253.393 198.899",
    stroke: "#BBBBBB",
    strokeWidth: 5.72067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.854 188.918L193.04 257.186",
    stroke: "#BBBBBB",
    strokeWidth: 5.72067,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 164.881,
    y: 97.749,
    width: 94,
    height: 246,
    fill: "#16171E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_373_3032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157.318,
    height: 256,
    fill: "white",
    transform: "translate(0 108.643) rotate(-43.677)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstronaut);
export default __webpack_public_path__ + "static/media/astronaut.1ee258c0462d4154491ed985a6e009c7.svg";
export { ForwardRef as ReactComponent };